/**
 * Rôles Keycloak (realm roles) exploités côté SDK.
 * Aligné sur l'enum `KeycloakRole` du backend (Mailvista-Api-Backend).
 */
export enum KeycloakRole {
    /** Administrateur IA — accès à la configuration du modèle d'IA de l'organisation */
    IA_ADMIN = "IA_ADMIN",
}
